import * as React from 'react';
import { Button, notification } from 'antd';
import { HsnInput } from '../../../schema';
import { HsnService } from '../../../service/HsnService';
import { hsnObject } from './constants';
import { HsnForm } from './HsnForm';

export class AddHsn extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hsn: props.hsn || JSON.parse(JSON.stringify(hsnObject)),
    };
  }

  hsnService = new HsnService();

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      hsn: nextProps.hsn || JSON.parse(JSON.stringify(hsnObject)),
    });
  }

  onChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => {
    const hsn = { ...this.state.hsn };
    hsn[e.target.name] = e.target.value;
    this.setState({ hsn });
  };

  saveHsn = () => {
    this.hsnService?.addHsn(
      this.state.hsn,
      (response) => {
        notification.success({
          message: 'Hsn ' + this.state.hsn.id ? 'Updated' : 'Added',
          description: `Hsn code ${this.state.hsn.hsnCode} was successfuly ${
            this.state.hsn.id ? 'Updated' : 'Added'
          }`,
        });
        this.props.handleTabChange?.('1');
      },
      (error) =>
        notification.error({
          message: 'Hsn ' + this.state.hsn.id ? 'Update Error' : 'Add Error',
          description: JSON.stringify(error),
        }),
    );
  };

  clear = () => {
    this.setState({ hsn: JSON.parse(JSON.stringify(hsnObject)) });
  };

  render() {
    return (
      <div>
        <HsnForm values={this.state.hsn} onChange={this.onChange} />
        <Button
          type="dashed"
          onClick={this.clear}
          children="Clear"
          style={{ width: '50%' }}
        />
        <Button
          type="primary"
          onClick={this.saveHsn}
          children="Submit"
          style={{ width: '50%' }}
        />
      </div>
    );
  }
}

interface Props {
  hsn?: HsnInput | null;
  handleTabChange?: (key) => void;
}

interface State {
  hsn: HsnInput;
}
